import { DisplayElementModel } from './display-element.model';
import { ImageStyleModel } from './image-style.model';
import { WireVideoDisplayElementApiModel } from '../../../Amplify/Wire/models/wire-video-display-element-api.model';
import { webVideoHelper } from '../../Misc/helpers/webVideo/webVideo.helper';

export class VideoDisplayElementModel extends DisplayElementModel {
    declare styles: ImageStyleModel;
    placeholderHeight: number = 120;

    url: string;
    embedUrl: string;
    caption: string;
    oldUrl: string;

    constructor(
        apiModel: WireVideoDisplayElementApiModel
    ) {
        super();
        this.isBoundToGlobalStyles = true;

        if (apiModel) {
            this.url = apiModel.url;
            this.caption = apiModel.caption;
            this.styles = new ImageStyleModel(apiModel.styles);
            this.embedUrl = webVideoHelper.getEmbedUrl(this.url);
        } else {
            this.styles = new ImageStyleModel();
        }
    }

    canRender(): boolean {
        return !!this.url;
    }

    toApi(): WireVideoDisplayElementApiModel {
        const apiModel = Object.assign(
            {},
            <WireVideoDisplayElementApiModel> {
                caption: this.caption,
                url: this.url,
                styles: JSON.parse(JSON.stringify(this.styles))
            },
        );

        return apiModel;
    }

    clone(): VideoDisplayElementModel {
        return new VideoDisplayElementModel(this.toApi()) as this;
    }

    async onUpdate(): Promise<boolean> {
        let changes = false;
        if (this.url !== this.oldUrl) {
            this.embedUrl = webVideoHelper.getEmbedUrl(this.url);

            changes = true;
        }

        this.oldUrl = this.url;

        return changes;
    }

    isEqual(other: VideoDisplayElementModel): boolean {
        if (this.url !== other.url) {
            return false;
        }

        if (this.caption !== other.caption) {
            return false;
        }

        if (!this.styles.equals(other.styles)) {
            return false;
        }

        return true;
    }
}
